
import Layout from "@/router/layouts/main-layout.vue";
import Sidebar from "@/components/side-bar.vue";
import { contentService } from "@/helpers/api-services/content.service";
import { authComputed } from "@/state/helpers";
import { profileComputed } from "@/state/helpers";
import { GoogleTrackingService } from "@/helpers/tracking-services/google-tracking-service";
import Card from "@/components/feed-card.vue";
import i18n from "@/i18n";

import { defineComponent } from "vue";
import { KcmCategory, KcmContent } from "@/types";
import { Route } from "vue-router";

declare interface ComponentData {
  contents: KcmContent[] | undefined;
  type: string;
  category: string;
  query: string;
  categories: KcmCategory[] | undefined;
  newCategory: string;
  newType: string;
  searchText: string;
  totalCount: number | undefined;
  rows: number | null;
  perPage: number;
  currentPage: number;
  oops: string | null;
}

export default defineComponent({
  components: { Layout, Sidebar, Card },
  data(): ComponentData {
    return {
      contents: undefined,
      type: "blog",
      category: "",
      query: "",
      categories: undefined,
      newCategory: "",
      newType: "blog",
      searchText: "",
      totalCount: undefined,
      rows: null,
      perPage: 8,
      currentPage: 1,
      oops: null,
    };
  },

  props: {
    page: {
      required: false,
      type: Number,
    },
  },

  computed: {
    ...authComputed,
    ...profileComputed,
  },

  methods: {
    async changePage(): Promise<void> {
      await contentService
        .getContents(
          this.currentPage - 1,
          this.perPage,
          this.type,
          i18n.locale,
          this.category,
          this.query
        )
        .then((result) => {
          this.contents = result.content;
        });
      const element = this.$refs["feed-wrapper"] as HTMLElement;
      const top = element.offsetTop;

      window.scrollTo(0, top);
    },

    async newSearch(): Promise<void> {
      this.currentPage = 1;
      this.type = this.newType;
      this.category = this.newCategory;
      this.query = this.searchText;
      this.newCategory = "";
      this.searchText = "";
      await contentService
        .getContents(
          this.currentPage - 1,
          this.perPage,
          this.type,
          i18n.locale,
          this.category,
          this.query
        )
        .then((result) => {
          if (result.total_count) {
            this.contents = result.content;
            this.totalCount = result.total_count;
            this.rows = Math.ceil(result.total_count / 8.0);
            GoogleTrackingService.modifyGoogleTagManager(
              "search",
              undefined,
              this.query,
              this.totalCount
            );
          }
        });

      this.changeURL();
    },

    changeURL(): void {
      let queryArray = [];
      if (this.query) {
        queryArray.push("s=" + this.query);
      }
      if (this.category) {
        queryArray.push("c=" + this.category);
      }
      if (this.type) {
        queryArray.push("t=" + this.type);
      }
      if (this.ppCode) {
        queryArray.push("a=" + this.ppCode);
      }

      let route = `/` + i18n.locale + `/search`;
      let queryString = `/?`;
      queryArray.forEach((query) => {
        queryString = queryString + query + "&";
      });
      queryString = queryString.substring(0, queryString.lastIndexOf("&"));

      route = route + queryString;

      history.pushState(null, "", route);
    },

    linkGen(pageNum: number): Partial<Route> {
      const root = this.$route.path.split("page")[0];
      let route = root.charAt(root.length - 1) === "/" ? root : root + "/";

      if (pageNum > 1 && this.page !== pageNum) {
        route += "page/" + pageNum + "/";
      }

      if (Object.keys(this.$route.query).length > 0) {
        route += "?";
        const queryVars = [];
        for (const key of Object.keys(this.$route.query)) {
          queryVars.push(key + "=" + this.$route.query[key]);
        }
        route += queryVars.join("&");
      }
      return { path: route };
    },

    categoryText: contentService.categoryText,
  },

  async mounted(): Promise<void> {
    this.currentPage = this.page ? this.page : 1;

    contentService.getCategories().then((result) => {
      this.categories = result.categories;
    });

    if (this.$route.query.s) {
      this.query = this.$route.query.s as string;
    }
    document.title =
      this.query + " | Search Results | " + this.title1 + " " + this.title2;
    if (this.$route.query.c) {
      this.category = this.$route.query.c as string;
    }
    if (this.$route.query.t) {
      if (this.$route.query.t.includes("videos") && this.authIsVideo) {
        this.type = this.$route.query.t as string;
        if (this.type === "blog,videos") {
          this.newType = "blog%2Cvideos";
        } else {
          this.newType = this.$route.query.t as string;
        }
      } else {
        this.type = "blog";
      }
    }

    if (this.$route.query.o) {
      this.oops = this.$route.query.o as string;
    }
    await contentService
      .getContents(
        this.currentPage - 1,
        this.perPage,
        this.type,
        i18n.locale,
        this.category,
        this.query
      )
      .then((result) => {
        if (result.total_count) {
          this.contents = result.content;
          this.totalCount = result.total_count;
          this.rows = Math.ceil(result.total_count / 8.0);
          GoogleTrackingService.modifyGoogleTagManager(
            "search",
            undefined,
            this.query,
            this.totalCount
          );
        }
      });
  },

  watch: {
    page(): void {
      this.currentPage = this.page ? this.page : 1;
    },
  },
});
